import {isObjectControl, RankedTester, rankWith} from "@jsonforms/core";

export const objectRendererTester: RankedTester = rankWith(
  3,
  isObjectControl
);
